/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 *
 */

//HTTP Status Codes
export const STATUS_OK = 200;
export const STATUS_NO_CONTENT = 204;
export const STATUS_NOT_FOUND = 404;


// URLs
export const VSP_LOGIN_URL = 'https://www.autopartners.net/gmentsso/UI/Login?goto=https://dealer.autopartners.net:443/portal/us/Pages/default.aspx';